
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import classof$1 from './classof.js';
import getMethod$1 from './get-method.js';
import isNullOrUndefined$1 from './is-null-or-undefined.js';
import iterators from './iterators.js';
import wellKnownSymbol$1 from './well-known-symbol.js';

var classof = classof$1;
var getMethod = getMethod$1;
var isNullOrUndefined = isNullOrUndefined$1;
var Iterators = iterators;
var wellKnownSymbol = wellKnownSymbol$1;

var ITERATOR = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};

export { getIteratorMethod as default };
//# sourceMappingURL=get-iterator-method.js.map
